import { __module as t } from "../../../_virtual/isIn.js";
import { a as o } from "./util/assertString.js";
import { t as r } from "./util/toString.js";
!function (t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = function (t, o) {
    if ((0, n.default)(t), "[object Array]" === Object.prototype.toString.call(o)) {
      var r,
        e = [];
      for (r in o) ({}).hasOwnProperty.call(o, r) && (e[r] = (0, f.default)(o[r]));
      return e.indexOf(t) >= 0;
    }
    return "object" === i(o) ? o.hasOwnProperty(t) : !!o && "function" == typeof o.indexOf && o.indexOf(t) >= 0;
  };
  var n = u(o),
    f = u(r);
  function u(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }
  function i(t) {
    return (i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }
  t.exports = e.default, t.exports.default = e.default;
}(t, t.exports);
var e = t.exports;
export { e as i };